import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'JushuitanShop',
    column_type: 'id',
  },
  created_at: {
    model_name: 'JushuitanShop',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'JushuitanShop',
    column_type: 'datetime',
  },
  shop_id: {
    model_name: 'JushuitanShop',
    column_type: 'integer',
  },
  shop_name: {
    model_name: 'JushuitanShop',
    column_type: 'string',
  },
  shop_type: {
    model_name: 'JushuitanShop',
    column_type: 'enum',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
